import { useIsMounted } from '@simplywallst/ui-core';
import { FairValueHistogramChart } from './components/FairValueHistogramChart';
import type { FairValueHistogramCompanyFragment } from './fairValueHistogramFragment';
import { FairValueHistogramSkeleton } from './components/FairValueHistogramSkeleton';

type Props = {
  company: FairValueHistogramCompanyFragment;
  height?: number;
};

export const FairValueHistogram = ({ company, height = 160 }: Props) => {
  const { count } = company.valuationHistogram ?? {};

  const isMounted = useIsMounted();

  if (!isMounted) return <FairValueHistogramSkeleton height={height} />;

  return (
    <div className="grid gap-x2" id="fair-value-histogram-chart-wrapper">
      <p className="m-0 text-sm text-solid">
        Valuation Range from {count} fair values
      </p>
      {company.valuationHistogram && (
        <FairValueHistogramChart company={company} height={height} />
      )}
    </div>
  );
};
